import { render } from "./DisputeResolution.vue?vue&type=template&id=382b3026&scoped=true"
import script from "./DisputeResolution.vue?vue&type=script&lang=js"
export * from "./DisputeResolution.vue?vue&type=script&lang=js"

import "./DisputeResolution.vue?vue&type=style&index=0&id=382b3026&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382b3026"]])

export default __exports__